export const navigationGroups = [
  { id: 'assistant', label: 'Bugün', items: ['home', 'mahmut-ai', 'gecmis-sohbetler'] },
  { id: 'sources', label: 'Kütüphane ve Sohbetler', items: ['mahmut-efendim', 'soru-cevap', 'kutuphane', 'dergah-kutuphanesi', 'konular', 'ayak-izleri'] },
  { id: 'journey', label: 'Dervişin Yolculuğu', items: ['dervisin-yolculugu', 'kuran-dinle', 'haftalik-dersler', 'canli-yayin', 'dua-bagisi', 'duyurular'] },
  { id: 'personal', label: 'Kişisel Alanım', items: ['kayitlar'] },
];

// Explicit product routes must never be shadowed by generated placeholder routes.
export function contentNavigationRoutes(items) {
 return items.filter(item=>!['/','/dergah-kutuphanesi','/mahmut-efendim-ai','/sohbet','/dua-bagisi','/kuran-dinle'].includes(item.to));
}
